import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { apiUrl, isApiUrl } from './api-url';
import { AuthService } from './auth.service';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const auth = inject(AuthService);
  const token = auth.accessToken;
  if (!isApiUrl(request.url)) {
    return next(request);
  }

  const apiRequest = request.clone({
    url: request.url.startsWith('/') ? apiUrl(request.url) : request.url,
    setHeaders: token ? { Authorization: `Bearer ${token}` } : {}
  });

  return next(apiRequest).pipe(
    catchError(error => {
      if (error?.status === 401) {
        auth.clearSession();
      }
      return throwError(() => error);
    })
  );
};
